import Service from './service';

export default class ProductionCapacityService extends Service {
  baseApi = '/production-capacity';

  async getCapacities(id) {
    const url = `${this.baseApi}/${id}`;
    return await this.getResource(url);
  }

  async getGeneralTotal() {
    const url = `${this.baseApi}/general-total`;
    return await this.getResource(url);
  }

  async putCapacities(id, body) {
    const url = `${this.baseApi}/${id}`;
    return await this.putResource(url, body);
  }
}
